import { useMemo } from 'react';
import type { FieldRendererProps, FieldDisplayProps } from '../../config/types';
import { Combobox, type ComboboxOption } from '@/components/ui/Combobox';
import { FYE_OPTIONS } from './data';
import { Text } from '@/components/ui/Text';

export function FyeSelectRenderer({ field, value, onChange, error }: FieldRendererProps) {
  const options: ComboboxOption[] = useMemo(
    () => FYE_OPTIONS.map((o) => ({ value: o.value, label: o.label })),
    [],
  );

  return (
    <Combobox
      options={options}
      value={(value as string) ?? ''}
      onValueChange={(v) => onChange(v)}
      placeholder={field.placeholder ?? 'Select financial year end...'}
      searchPlaceholder="Search..."
      disabled={field.isDisabled}
      clearable
      className={`bg-surface-elevated ${error ? 'border-danger' : ''}`}
    />
  );
}

export function FyeSelectDisplay({ value }: FieldDisplayProps) {
  const str = value as string | null | undefined;
  if (!str) return <Text variant="body-sm" weight="medium" as="span">—</Text>;
  return <Text variant="body-sm" weight="medium" as="span">{str}</Text>;
}
